//引入vue
import Vue from "vue";
//引入vue-router
import VueRouter from "vue-router";

Vue.use(VueRouter)
    // import routes from "./router"

const routes = [{
        path: '/',
        redirect: "home"
    }, {
        path: "/login",
        name: "Login",
        component: () =>
            import ("@/views/login/login.vue"),
    }, {
        path: "/index",
        name: "Index",
        component: () =>
            import ("@/views/index/index.vue"),
    }, {
        path: "/home",
        name: "Home",
        component: () =>
            import ("@/views/home/home.vue"),
    }, {
        path: "/quotation",
        name: "Quotation",
        component: () =>
            import ("@/views/quotation/quotation.vue"),
    },
    {
        path: "/policyform",
        name: "Policyform",
        component: () =>
            import ("@/views/policyform/policyform.vue"),
    },
    {
        path: "/upload",
        name: "Upload",
        component: () =>
            import ("@/views/upload/upload.vue"),
    },

    {
        path: "/success",
        name: "Success",
        component: () =>
            import ("@/views/success/success.vue"),
    },
]

const router = new VueRouter({
    //ES6简写，等于routes：routes
    routes
});

//抛出这个这个实例对象方便外部读取以及访问
export default router